$(document).ready(function () {
  $('.bundle_gallery').each(function () {
    const $gallery = $(this);
    const $slides = $gallery.find('.slides img');
    const $bullets = $gallery.find('.bullets');
    let currentIndex = 0;

    function showSlide(index) {
      $slides.hide().eq(index).show();
      $gallery.find('.bullet').removeClass('active').eq(index).addClass('active');
      currentIndex = index;
    }

    // Init
    $slides.hide().eq(0).show();

    // Bullet Navigation
    if ($bullets.length) {
      $slides.each(function (i) {
        const $bullet = $('<span class="bullet"></span>');
        if (i === 0) $bullet.addClass('active');
        $bullet.on('click', function () {
          showSlide(i);
        });
        $bullets.append($bullet);
      });
    }

    // Arrow Navigation
    const $prev = $('<button class="arrow prev" aria-label="Previous slide"><span class="gg-chevron-left"></span></button>');
    const $next = $('<button class="arrow next" aria-label="Next slide"><span class="gg-chevron-right"></span></button>');
    $gallery.append($prev, $next);
    $prev.on('click', function () {
      let prev = (currentIndex - 1 + $slides.length) % $slides.length;
      showSlide(prev);
    });
    $next.on('click', function () {
      let next = (currentIndex + 1) % $slides.length;
      showSlide(next);
    });

    // Swipe Support
    let touchStartX = 0;
    let touchEndX = 0;

    $gallery.find('.slides').on('touchstart', function (e) {
      touchStartX = e.originalEvent.touches[0].clientX;
    });

    $gallery.find('.slides').on('touchend', function (e) {
      touchEndX = e.originalEvent.changedTouches[0].clientX;

      if (touchEndX < touchStartX - 30) {
        let next = (currentIndex + 1) % $slides.length;
        showSlide(next);
      } else if (touchEndX > touchStartX + 30) {
        let prev = (currentIndex - 1 + $slides.length) % $slides.length;
        showSlide(prev);
      }
    });
  });
});

// Bundle options

$(document).ready(function () {
  const radios = document.querySelectorAll('.option_box');
  const labels = document.querySelectorAll('.option_label');
  const freeGifts = document.querySelectorAll('.free_gift');

  setTimeout(function () {
      $('#option2').prop('checked', true);
  }, 100);

  function updateUI() {
    // Update checked class
    labels.forEach(label => label.classList.remove('checked'));
    radios.forEach(radio => {
      if (radio.checked) {
        const label = document.querySelector(`label[for="${radio.id}"]`);
        label.classList.add('checked');

        // Handle free gifts logic
        if (radio.id === 'option1') {
          freeGifts.forEach(gift => gift.classList.add('available'));
          var radioQant = $('#option1').data('quant');
          var radioDiscountAmount = $('#option1').data('discount-amount');
          $('input#bundle_option').val(radioQant);
          $('input#bundle_discount').val(radioDiscountAmount);

          $('#freeGift1 .free_gift_inactive').hide();
          $('#freeGift2 .free_gift_inactive').hide();
          $('#freeGift3 .free_gift_inactive').hide();
          $('#freeGift4 .free_gift_inactive').hide();

          $('#freeGift1 .free_gift_active').show();
          $('#freeGift2 .free_gift_active').show();
          $('#freeGift3 .free_gift_active').show();
          $('#freeGift4 .free_gift_active').show();
        } else if (radio.id === 'option2') {
          freeGifts.forEach(gift => gift.classList.add('available'));
          var radioQant = $('#option2').data('quant');
          var radioDiscountAmount = $('#option2').data('discount-amount');
          $('input#bundle_option').val(radioQant);
          $('input#bundle_discount').val(radioDiscountAmount);

          $('#freeGift1 .free_gift_inactive').hide();
          $('#freeGift2 .free_gift_inactive').hide();
          $('#freeGift3 .free_gift_inactive').hide();
          $('#freeGift4 .free_gift_inactive').show();

          $('#freeGift1 .free_gift_active').show();
          $('#freeGift2 .free_gift_active').show();
          $('#freeGift3 .free_gift_active').show();
          $('#freeGift4 .free_gift_active').hide();
        } else if (radio.id === 'option3') {
          freeGifts.forEach((gift, index) => {
            gift.classList.toggle('available', index === 0);
          });
          var radioQant = $('#option3').data('quant');
          var radioDiscountAmount = $('#option3').data('discount-amount');
          $('input#bundle_option').val(radioQant);
          $('input#bundle_discount').val(radioDiscountAmount);

          $('#freeGift1 .free_gift_inactive').hide();
          $('#freeGift2 .free_gift_inactive').show();
          $('#freeGift3 .free_gift_inactive').show();
          $('#freeGift4 .free_gift_inactive').show();

          $('#freeGift1 .free_gift_active').show();
          $('#freeGift2 .free_gift_active').hide();
          $('#freeGift3 .free_gift_active').hide();
          $('#freeGift4 .free_gift_active').hide();
        }
      }
    });
  }

  radios.forEach(radio => {
    radio.addEventListener('change', updateUI);
  });

  // Initial setup
  updateUI();
});

// Free Gifts Info
$(document).ready(function () {

  $(document).on('click', '.free_gift.available', function () {
    var modalImgURL = $(this).data('alt-img');
    var giftName = $(this).find('.gift_name').text();
    var giftText = $(this).find('.modal_text').val();
    $('.bundle_modal_box h4').text(giftName);
    $('.bundle_modal_box p').text(giftText);
    $('.bundle_modal_box .modal_image').attr('src', modalImgURL);
    $('.bundle_modal').fadeIn();
  });

  $('.bundle_modal_box button').click(function () {
    $('.bundle_modal').hide();
    $('.bundle_modal .modal_add').hide();
  });

  $('.bundle_modal').click(function (e) {
    if (!$(e.target).closest('.bundle_modal_box').length) {
      $(this).hide();
      $('.bundle_modal .modal_add').hide();
    }
  });
  
});

// Variant Items Info
$(document).ready(function () {

  $('.info_button').click(function () {
    var modalImgURL = $(this).data('modal-img');
    var modalTitle = $(this).data('modal-title');
    var modalText = $(this).data('modal-text');
    var modalID = $(this).data('id');
    $('.bundle_modal_box h4').text(modalTitle);
    $('.bundle_modal_box p').text(modalText);
    $('.bundle_modal_box .modal_image').attr('src', modalImgURL);
    $('.bundle_modal_box .modal_add').attr('data-id', modalID);
    $('.bundle_modal .modal_add').show();
    $('.bundle_modal').fadeIn();
  });

});

// Bundle Handling

$(document).ready(function () {

  // Update checkout button

  function updateCheckoutButton() {
    var parts = [];
    totalQuantity = 0;
  
    for (var id in cartItems) {
      if (cartItems.hasOwnProperty(id)) {
        var qty = cartItems[id];
        totalQuantity += qty;
        parts.push(id + ':' + qty);
      }
    }
  
    var bundleOption = $('input#bundle_option').val();
    var remainingQuantity = bundleOption - totalQuantity;

    var freeGiftItems = null;
    var highestMatch = -1;
    
    $(".free_gift_items").each(function() {
      var minItems = parseInt($(this).data('min-items'), 10);
    
      if (totalQuantity >= minItems && minItems > highestMatch) {
        highestMatch = minItems;
        freeGiftItems = $(this).val();
      }
    });

    console.log(freeGiftItems);

    var cartURL = '/cart/' + parts.join(',') + ',' + freeGiftItems + '?discount=FreeGifts';

    var checkoutButtonText;

    if (remainingQuantity > 1) {
      var checkoutButtonText = 'Select ' + remainingQuantity + ' more mirrors';
    } else {
      if (bundleOption == 1) {
        var checkoutButtonText = 'Select your mirror';
      } else {
        var checkoutButtonText = 'Select your last mirror';
      }
    }

    if ($('input#market').val() === 'CA') {
      cartURL += '?properties=eyJjYW5hZGFfYnVuZGxlIjogInRydWUifQ';
    }

    if (totalQuantity >= bundleOption) {
      $('.checkout_button').removeClass('disabled').attr('href', cartURL).html('Checkout <img class="arrow_fix" src="https://cdn.shopify.com/s/files/1/1069/1900/files/lp-right-arrow.svg?v=1711494815">');

      // Update logic later for increased dynamicism
      
      if (totalQuantity >= 6) {
        var bundleAmount = $('input#bundle_1_discount').val();
      } else if (totalQuantity >= 3) {
        var bundleAmount = $('input#bundle_2_discount').val();
      } else if (totalQuantity >= 1) {
        var bundleAmount = $('input#bundle_3_discount').val();
      }
      
      // Debug
      console.log('checkout ready');
    } else {
      $('.checkout_button').addClass('disabled').removeAttr('href').text(checkoutButtonText);

      var bundleAmount = $('input#bundle_discount').val();
      
      // Debug
      console.log('checkout not ready');
    }

    // Update logic later for increased dynamicism

    var giftsUnlocked = 0;
    
    if (totalQuantity >= 6) {
      var giftsUnlocked = 4;
    } else if (totalQuantity >= 3) {
      var giftsUnlocked = 3;
    } else if (totalQuantity >= 1) {
      var giftsUnlocked = 1;
    }
    
    let totalFreebiePrice = 0;
  
    $('.free_gift.available').each(function() {
      const price = parseFloat($(this).data('price'));
      if (!isNaN(price)) {
        totalFreebiePrice += price;
      }
    });

    var totalSavingsNoGifts = bundleAmount * totalQuantity;
    var totalSavings = Math.floor((totalSavingsNoGifts + totalFreebiePrice) * 100) / 100;

    $('span#gifts_unlocked span').html(giftsUnlocked);
    $('span#total_savings span').html(totalSavings);

    // Debug
    console.log('totalQuantity:', totalQuantity);
    console.log('Bundle option:' + bundleOption);
    console.log('Bundle amount:' + bundleAmount);
    console.log('Items price total:' + totalSavingsNoGifts);
    console.log('Freebie price total:' + totalFreebiePrice);
    console.log('Total Savings:' + totalSavings);
    console.log('Gifts Unlocked:' + giftsUnlocked);
    
  }

  function updatePrevStepButton() {
    var bundleNumber = $('input#bundle_option').val();
    if (bundleNumber > 1) {
      $('.prev_step span').text('Select at least ' + bundleNumber + ' mirrors');
    } else {
      $('.prev_step span').text('Select at least 1 mirror');
    }
    console.log(bundleNumber);
  }

  // Step toggle
  
  $('.next_step button').click(function () {
    $('.bundle').addClass('second_step_active');
    $('.bunde-lp-section').hide();
    $('#lp_topbar_2').show();
    $('.checkout_button_wrapper').css({
      visibility: 'visible',
      height: 'auto'
    });
    updatePrevStepButton();
    setTimeout(function () {
        updateCheckoutButton();
    }, 100);
  });
  
  $('.sticky_button button').click(function () {
    $(window).scrollTop(0);
    $('.bundle').addClass('second_step_active');
    $('.bunde-lp-section').hide();
    $('#lp_topbar_2').show();
    $('.checkout_button_wrapper').css({
      visibility: 'visible',
      height: 'auto'
    });
    updatePrevStepButton();
    setTimeout(function () {
        updateCheckoutButton();
    }, 100);
  });
  
  $('.prev_step button').click(function () {
    $('.bundle').removeClass('second_step_active');
    $('.bunde-lp-section').show();
    $('#lp_topbar_2').hide();
    $('.checkout_button_wrapper').css({
      visibility: 'hidden',
      height: '0'
    });
  });

  // Add variants

  var cartItems = {};
  
  // Show the quantity selector on Add button click
  $('.quant_selectors .add').click(function () {
    
    const $container = $(this).closest('.quant_selectors');
    const variantId = $container.data('id');

    $(this).hide();
    $container.find('.quantity-selector').show();
    $container.find('.quantity-input').val(1);

    cartItems[variantId] = 1;
    updateCheckoutButton();
  });

  // Increase quantity
  $('.quant_selectors .increase').click(function () {
    const $container = $(this).closest('.quant_selectors');
    const $input = $container.find('.quantity-input');
    const variantId = $container.data('id');

    let current = parseInt($input.val(), 10);
    current += 1;
    $input.val(current);

    cartItems[variantId] = current;
    updateCheckoutButton();
  });

  // Decrease quantity
  $('.quant_selectors .decrease').click(function () {
    const $container = $(this).closest('.quant_selectors');
    const $input = $container.find('.quantity-input');
    const variantId = $container.data('id');

    let current = parseInt($input.val(), 10);
    current -= 1;

    if (current <= 0) {
      $input.val(0);
      $container.find('.quantity-selector').hide();
      $container.find('.add').show();
      delete cartItems[variantId];
    } else {
      $input.val(current);
      cartItems[variantId] = current;
    }

    updateCheckoutButton();
  });

  // Handle modal 'Add' button
  
  $('.modal_add').click(function () {
    const variantId = $(this).data('id');
  
    // Show quantity selector on all matching .quant_selectors
    const $matchingSelectors = $('.quant_selectors').filter(function () {
      return $(this).data('id') == variantId;
    });
  
    $matchingSelectors.each(function () {
      $(this).find('.quantity-selector').show();
      $(this).find('.quantity-input').val(1);
    });
  
    cartItems[variantId] = 1;
    updateCheckoutButton();

    $(".quant_selectors").each(function() {
        if ($(this).data('id') == variantId) {
          $(this).find('.add').hide();
        }
    });
  });

});

// Free Gifts Date Widget

$(document).ready(function() {
    var today = new Date();
    var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var formattedDate = months[today.getMonth()] + " " + today.getDate();
    $(".free_gifts_date span").text(formattedDate);
});

$(document).ready(function() {
    $(window).on('scroll', function() {
        var windowHeight = $(window).height();
        var documentHeight = $(document).height();
        var scrollTop = $(window).scrollTop();

        var bottomScrollPosition = scrollTop + windowHeight;
        var scrollFromBottom = documentHeight - bottomScrollPosition;

        var topDistance = $('.bundle_wrapper').height();

        var topThreshold = topDistance;
        var bottomThreshold = 350;

        if (scrollTop > topThreshold && scrollFromBottom > bottomThreshold) {
            $('.sticky_button').show();
        } else {
            $('.sticky_button').hide();
        }
        if (scrollTop > 15) {
            $('.show_sticky').show();
        }
    });
    $('.sticky_button .select_bundle').on('click', function(e){
      e.preventDefault();
      $('html, body').animate({
        scrollTop: 51
      }, 600);
    });


});

